import { combineReducers } from '@reduxjs/toolkit'
import badge from './badge.store'
import alert from './alert.store'

export const rootReducer = combineReducers({
  badge,
  alert,
})
